import { useState, useEffect } from "react";

let mapInstance: naver.maps.Map | null = null;

const loadScript = (src: string, callback: () => void) => {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = src;
  script.onload = () => callback();
  document.head.appendChild(script);
};

function MapInformation({
  latitude,
  longitude,
}: {
  latitude: number;
  longitude: number;
}) {
  // 지도 로딩 상태
  const [isMapLoaded, setMapLoaded] = useState(false);

  const initMap = () => {
    const mapOptions = {
      zoomControl: true,
      zoomControlOptions: {
        style: naver.maps.ZoomControlStyle.SMALL,
        position: naver.maps.Position.TOP_RIGHT,
      },
      center: new naver.maps.LatLng(latitude, longitude),
      zoom: 18,
    };

    if (document.getElementById("map")) {
      mapInstance = new naver.maps.Map("map", mapOptions);

      // Marker 생성 (mapInstance가 null이 아닐 때만 생성)
      if (mapInstance) {
        const marker = new naver.maps.Marker({
          position: new naver.maps.LatLng(latitude, longitude),
          map: mapInstance,
        });

        naver.maps.Event.addListener(marker, "click", () => {
          mapInstance?.setCenter(new naver.maps.LatLng(latitude, longitude));
          mapInstance?.setZoom(16);
        });
      }
    }

    setMapLoaded(true);
  };

  useEffect(() => {
    if (typeof naver === "undefined") {
      loadScript(
        "https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=lfq42znk8e",
        initMap
      );
    } else {
      initMap();
    }
  }, [latitude, longitude]);

  return (
    <>
      <div
        id="map"
        className="pc-image"
        style={{
          width: "100%",
        }}
      ></div>
    </>
  );
}

export default MapInformation;
